const UsloviKoriscenja = () => {
  return (
    <div className="w-full h-full bg-white pb-8">
      <div className="pt-36 w-8/12 h-full mx-auto no-more-tailwind">
        <p style={{ textAlign: 'center' }}>
          Portal&nbsp;
          <a href="http://dnevno.me/" target="_blank" rel="noreferrer">
            DNEVNO.ME
          </a>
          &nbsp;omogućava korišćenje usluga i sadržaja web platforme i
          aplikacije u skladu s navedenim Pravilima i uslovima korišćenja.
        </p>
        <p style={{ textAlign: 'center' }}>
          <a href="http://dnevno.me/" target="_blank" rel="noreferrer">
            DNEVNO.ME
          </a>
          &nbsp;sastoji se od vlastitog sadržaja, kao i sadržaja oglašivača,
          besplatnih sadržaja, te linkova na druge stranice.
        </p>
        <p style={{ textAlign: 'center' }}>
          Svi posjetioci imaju pravo da besplatno (osim ako nije drugačije
          navedeno) koriste sadržaj portala&nbsp;
          <a href="http://dnevno.me/" target="_blank" rel="noreferrer">
            DNEVNO.ME
          </a>
          , ukoliko ne krše uslove korišćenja.
        </p>
        <p style={{ textAlign: 'center' }}>
          Korisnici Portala ne smiju ni na koji način objavljene informacije
          koristiti u svrhe izazivanja rasne, vjerske i nacionalne mržnje i
          netrpeljivosti ili ih koristiti u bilo kojem kontekstu koji sadrži
          vulgarnosti i pozive na nasilje.
        </p>
        <p style={{ textAlign: 'center' }}>
          Prenošenje sadržaja portala&nbsp;
          <a href="http://dnevno.me/" target="_blank" rel="noreferrer">
            DNEVNO.ME
          </a>
          &nbsp;dozvoljeno je, u zavisnosti od sadržaja, uz prethodno odobrenje
          vlasnika prava, uz obavezno navođenje izvora ili linkovanje izvornog
          sadržaja portala&nbsp;
          <a href="http://dnevno.me/" target="_blank" rel="noreferrer">
            DNEVNO.ME
          </a>
        </p>
        <p style={{ textAlign: 'center' }}>
          Neovlašćeno korištenje bilo kojeg sadržaja portala i poslovnog imena
          smatra se kršenjem autorskih prava portala&nbsp;
          <a href="http://dnevno.me/" target="_blank" rel="noreferrer">
            DNEVNO.ME
          </a>
          &nbsp;i podložno je tužbi.
        </p>
        <p style={{ textAlign: 'center' }}>
          <a href="http://dnevno.me/" rel="nofollow noreferrer" target="_blank">
            DNEVNO.ME
          </a>
          &nbsp;poštuje privatnost svojih korisnika i posjetilaca.&nbsp;
          <a href="http://dnevno.me/" rel="nofollow noreferrer" target="_blank">
            DNEVNO.ME
          </a>
          &nbsp;može koristiti podatke o korisnicima dobijene tokom korišćenja
          portala, uključujući podatke o računaru i internet provajderu, ili
          podatke obezbijeđene od posjetilaca ili korisnika. Podaci o
          korisnicima mogu uključivati informacije koje se mogu individualno
          identifikovati u odnosu na određeno lice, kao što je IP adresa, kao i
          zbirne informacije o korisnicima. Ovi podaci pomažu nam da razumijemo
          način na koji se portal koristi, što nam omogućava da poboljšamo
          sadržaj i usmjerimo ga prema interesima naše publike.
        </p>
        <p style={{ textAlign: 'center' }}>
          <a href="http://dnevno.me/" rel="nofollow noreferrer" target="_blank">
            DNEVNO.ME
          </a>
          &nbsp;garantuje čuvanje privatnosti korisnika portala, osim u slučaju
          teškog kršenja pravila&nbsp;
          <a href="http://dnevno.me/" rel="nofollow noreferrer" target="_blank">
            DNEVNO.ME
          </a>
          &nbsp;ili nezakonitih aktivnosti korisnika.
        </p>
        <p style={{ textAlign: 'center' }}>
          Portal nije odgovoran za kršenje autorskih prava u vezi snimaka i
          sadržaja koji se postavljaju na sajtovima poput YouTube, Google,
          Yahoo… Samim tim ukoliko postoji sadržaj za koji smatrate da se, ovom
          slučaju, krši autorska prava, molimo vas da se obratite sajtovima na
          kojima su postavljeni takvi snimci i prijavite ih kako bi bili
          uklonjeni.
        </p>
        <p style={{ textAlign: 'center' }}>
          Saglasni ste da ste vi odgovorni za očuvanje povjerljivosti lozinki
          koje su u vezi sa bilo kojim nalogom koji koristite da biste
          pristupili portalu&nbsp;
          <a href="http://dnevno.me/" target="_blank" rel="noreferrer">
            DNEVNO.ME
          </a>
          . U skladu sa tim, saglasni ste da ćete jedino vi biti odgovorni za
          sve aktivnosti na vašem nalogu. Portal nije odgovoran za štetu koja
          može nastati usljed zloupotrebe naloga od trećih lica. Ako primijetite
          bilo kakvo neovlašćeno korišćenje lozinke ili naloga, saglasni ste da
          ćete odmah obavijestiti portal&nbsp;
          <a href="http://dnevno.me/" target="_blank" rel="noreferrer">
            DNEVNO.ME
          </a>
          .
        </p>
        <p style={{ textAlign: 'center' }}>
          Korišćenjem i/ili registracijom na&nbsp;
          <a href="http://dnevno.me/" target="_blank" rel="noreferrer">
            DNEVNO.ME
          </a>
          , korisnik prihvata uslove korišćenja, kao i sve moguće izmjene i
          dopune. Ukoliko nijeste saglasni s uslovima koji su ovdje navedeni,
          molimo vas da ne budete korisnik/čitalac portala&nbsp;
          <a href="http://dnevno.me/" target="_blank" rel="noreferrer">
            DNEVNO.ME
          </a>
          .
        </p>
      </div>
    </div>
  )
}

export default UsloviKoriscenja
